<!-- Page Header Start-->
<div
  #header
  class="page-header"
  [class.close_icon]="navServices.collapseSidebar"
>
  <div class="header-wrapper row m-0 p-0">
    <div
      class="d-flex align-items-center main-header px-0 pt-xl-0 pt-1 flex-wrap flex-xl-nowrap"
    >
      <img
        class="logo-img order-1"
        [src]="imageData"
        onerror="this.src='../../../../assets/SVGIcons/logo.svg'"
        id="onlyImage"
        alt=""
      />
      <nav
        class="sidebar-main main-header-nav p-0 order-3 order-xl-2 d-flex align-items-end justify-content-lg-between justify-content-md-between"
      >
        <div
          class="left-arrow d-block d-xl-none"
          id="left-arrow"
          (click)="scrollLeft()"
        >
          <app-svg iconType="Polygon1"></app-svg>
        </div>
        <div #widgetsContent id="sidebar-menu">
          <ul class="sidebar-links custom-scrollbar">
            <li
              [class]="
                menuItem.headTitle1 ? 'sidebar-main-title' : 'sidebar-list'
              "
              *ngFor="let menuItem of menuItems"
              [ngClass]="{ active: menuItem.active }"
            >
              <a
                href="javascript:void(0)"
                class="sidebar-link sidebar-title"
                [class.link-nav]="!menuItem.children"
                [ngClass]="{ active: menuItem.active }"
                *ngIf="menuItem.type === 'sub'"
                (click)="toggletNavActive(menuItem)"
              >
                <span>{{ menuItem.title | translate }}</span>
              </a>
              <!-- Link -->
              <a
                [routerLink]="!menuItem.type ? null : [menuItem.path]"
                routerLinkActive="active"
                class="sidebar-link sidebar-title"
                [class.link-nav]="!menuItem.children"
                [ngClass]="{ active: menuItem.active }"
                *ngIf="menuItem.type === 'link'"
              >
                <span>{{ menuItem.title | translate }}</span>
              </a>
              <!-- External Link -->
              <a
                href="{{ !menuItem.type ? null : menuItem.path }}"
                class="sidebar-link sidebar-title"
                [class.link-nav]="!menuItem.children"
                [ngClass]="{ active: menuItem.active }"
                *ngIf="menuItem.type === 'extLink'"
              >
                <span>{{ menuItem.title | translate }}</span>
              </a>
              <!-- External Tab Link -->
              <a
                href="{{ !menuItem.type ? null : menuItem.path }}"
                target="_blank"
                class="sidebar-link sidebar-title"
                [class.link-nav]="!menuItem.children"
                [ngClass]="{ active: menuItem.active }"
                *ngIf="menuItem.type === 'extTabLink'"
              >
                <span>{{ menuItem.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="right-arrow d-block d-xl-none"
          id="right-arrow"
          (click)="scrollRight()"
        >
              <app-svg iconType="Polygon2"></app-svg>

        </div>
      </nav>
      <div
        class="p-0 order-2 order-xl-3 nav-content-right d-flex me-3"
      >
          <ul class="nav-menus d-flex justify-content-center align-items-center">

          <li>
             <app-svg class="lh-1" iconType="SearchBig"></app-svg>
          </li>

          <li
            class="addIcon position-relative {{
              activeIcon == 'add' ? 'active' : ''
            }}"
            (click)="
              addListShow('add');
              activeIcon = 'add';
              showlist == false ? (activeIcon = '') : (activeIcon = 'add')
            "
          >
            <div
              class="position-absolute"
              (mouseleave)="showlist = false; currentNav = ''; activeIcon = ''"
            >
              <div class="list-wrap" *ngIf="showlist">
                <ol
                  class="add-list-item"
                  *ngFor="let listitem of addiconList; let i = index;let f=first"
                >
                  <li>
                    <span
                      (click)="selectedItem(i);openAddEditCompanyModal(listitem.name);openAddEditAddContactModal(listitem.name);
                      ;openAddRequirement(listitem.name);addOffer(listitem.name)"
                      [ngClass]="{ active: listitem.selected,'fw-semibold':f}"
                      >{{ listitem.name }}</span
                    >
                  </li>
                </ol>
              </div>
            </div>

            <app-svg class="lh-1" iconType="Add" ></app-svg>
          </li>
          <li
            class="{{ activeIcon == 'tasks' ? 'active' : '' }}"
            (click)="toggelNotificationSideBar('tasks',clickValue);clickValue = !clickValue; activeIcon = 'tasks'"
          >
            <app-svg iconType="AddTask" class="task lh-1"></app-svg>
          </li>
          <li
            class="{{ activeIcon == 'notifications' ? 'active' : '' }}"
            (click)="
              toggelNotificationSideBar('notifications',clickValue);clickValue = !clickValue;
              activeIcon = 'notifications'
            "
          >
            <app-svg class="lh-1" iconType="Notification"></app-svg>
          </li>
          <li class="profile-nav onhover-dropdown p-0">
            <app-my-account></app-my-account>
          </li>
        </ul>
      </div>
    </div>
    <!-- Sub2 -->
    <nav class="sidebar-main sub-header sub-header-nav p-0 p-r-0 p-l-0  order-3 order-xl-2 d-flex align-items-end justify-content-lg-between justify-content-md-between">
     <div
     *ngIf="showSecondary"
     class="left-arrow"
      id="left-arrow"
      [class.d-none]="leftArrowNone"
      (click)="subscrollLeft()"
     >
                 <app-svg iconType="Polygon12"></app-svg>

      </div>
      <div id="sidebar-menu-nav">
        <ul #sidebarMenu  class="sidebar-links custom-scrollbar" style="overflow: hidden; white-space: nowrap; display: flex;">
          <li
            [class]="
              menuItem.headTitle1 ? 'sidebar-main-title' : 'sidebar-list'
            "
            *ngFor="let menuItem of menuItems"
            [ngClass]="{ active: menuItem.active }"
          >
            <!-- 2nd Level Menu -->
            <ul 
              class="sidebar-submenu sub-menu-item ms-xl-5 ms-0"
              [ngClass]="{ active: menuItem.active }"
              [ngClass]="{
                'menu-open': menuItem.active,
                'menu-close': !menuItem.active
              }"
              *ngIf="menuItem.children && showSecondary"
              [style.display]="menuItem.active ? 'flex' : 'none'"
            >
              <li
                *ngFor="let childrenItem of menuItem.children"
                [ngClass]="{ active: childrenItem.active }"
              >
                <!-- Sub -->
                <a
                  class="submenu-title"
                  href="javascript:void(0)"
                  *ngIf="childrenItem.type === 'sub'"
                  (click)="toggletNavActive(childrenItem)"
                >
                  <span class="text-nowrap"> {{ childrenItem.title | translate }}</span>
                </a>
                <!-- Link -->
                <a
                  class="submenu-title align-items-center"
                  (click)="addTabs(childrenItem)"
                  [routerLink]="
                    !childrenItem.type
                      ? null
                      : 'admin/system-settings' == [childrenItem.path] || 'admin/company-settings' == [childrenItem.path]
                      ? null
                      : [childrenItem.path]
                  "
                  *ngIf="childrenItem.type === 'link'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <app-svg-icon [src]="childrenItem.icon"> </app-svg-icon>

                  <span  class="text-nowrap">{{ childrenItem.title | translate }}</span>
                </a>
                <!-- External Link -->
                <a
                  class="submenu-title"
                  href="{{ !childrenItem.type ? null : childrenItem.path }}"
                  *ngIf="childrenItem.type === 'extLink'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <span  class="text-nowrap">{{ childrenItem.title | translate }}</span>
                </a>
                <!-- External Tab Link -->
                <a
                  class="submenu-title"
                  href="{{ !childrenItem.type ? null : childrenItem.path }}"
                  target="_blank"
                  *ngIf="childrenItem.type === 'extTabLink'"
                >
                  <span  class="text-nowrap">{{ childrenItem.title | translate }}</span>
                </a>
              </li>
              <li closeMenuTab class="collapse-arrow" *ngIf="menuItem.children.length > 0">
                <app-svg-icon
                  (click)="closeNavActive(menuItem)"
                  [src]="'./assets/SVGIcons/downArrow1.svg'"
                ></app-svg-icon>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div style=" margin-left: 20px;"
      *ngIf="showSecondary"
      class="right-arrow"
      id="right-arrow"
      [class.d-none]="rightArrowNone"
      (click)="subscrollRight()"
    >
    <app-svg *ngIf="showSecondary" class="d-lg-block d-xl-none" iconType="Polygon11"></app-svg>

    </div>
    </nav>
  </div>
</div>
<!-- Page Header Ends -->
